import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import hr from "./hr-HR";
import en from "./en-EN";
import * as kbcOverrides from "./overrides/kbc-overrides";
import helper from "@/shared/helper";

const { isObjectNotNullishOrEmpty } = helper;

export const defaultLanguage = "hr-HR";

export const getLanguage = (): string => {
	const language = JSON.parse(localStorage.getItem("profileData") ?? "{}")?.selectedLanguage || defaultLanguage;
	return language;
};

const addOverrides = overridesModule => {
	const { enOverrides, hrOverrides } = overridesModule || {};

	if (isObjectNotNullishOrEmpty(hrOverrides)) {
		i18n.addResourceBundle("hr", "translation", hrOverrides, true, true);
	}

	if (isObjectNotNullishOrEmpty(enOverrides)) {
		i18n.addResourceBundle("en", "translation", enOverrides, true, true);
	}
};

const resources = {
	hr: {
		translation: hr
	},
	en: {
		translation: en
	}
};

i18n.use(initReactI18next).init({
	resources,
	lng: JSON.parse(localStorage.getItem("profileData"))?.selectedLanguage || "hr-HR",
	interpolation: {
		escapeValue: false
	}
});

const overridesKey = import.meta.env.VITE_OVERRIDE_TRANSLATION_KEY || null;

if (overridesKey) {
	// key in .env variables must match the case in switch statement
	// if it matches, overrides from existing import file are added
	switch (overridesKey.toLowerCase()) {
		case "kbc":
			addOverrides(kbcOverrides);
			break;
		default:
			break;
	}
}

export default i18n;
